import { AllergenLogic } from 'enums/allergenLogic';
import { AllergenLogicMap } from 'types/Allergen/AllergenLogicMap';
import * as Allergen from 'types/BaseIngredient/Search/Allergen';
import * as Icon from 'types/Icon/Icon';
import * as StringList from 'types/_general/Search/StringList';
import * as SelectItemList from 'types/_general/SelectItemList';
import * as AllergenList from 'types/_general/Store/AllergenList';

export type Type = Allergen.Type[];

export function create(): Type {
	return [];
}

export function mapToIcons(obj: Type, allergensUserSet: Set<string>): (Icon.Type | null)[] {
	return obj.keep((e: Allergen.Type) => {
		return Allergen.mapToIcon(e, allergensUserSet);
	});
}

export function mapToSelectItemList(obj: AllergenList.Type): SelectItemList.Type {
	const output = SelectItemList.create();

	obj.map((x) => {
		output.push({
			display: x.display,
			iconSvgUrl: x.iconSvgUrl,
			id: `${x.id}:${x.logic}`,
			name: x.name,
		});
	});

	return output;
}

export function mapStringListToApi(input: StringList.Type): AllergenLogicMap | null {
	const output: AllergenLogicMap = {};
	input.forEach((x) => {
		const split = x.split(':');
		const id: string = split[0];
		const logic: AllergenLogic = split[1] as AllergenLogic;
		output[id] = logic;
	});
	return output;
}
